import React from 'react'
import { Box, Button, Typography, CircularProgress, Link, Alert, Paper } from '@mui/material'
import VerificationRecordItem from '../VerificationRecordItem'
import ModalAlert from '../ModalAlert'

export default function DnsStep({ domainName, dnsRecords, onVerify, isLoading, error, onBack }) {
  if (!dnsRecords && !isLoading) {
    return (
      <Box sx={{ p: 2 }}>
        <Alert severity='warning'>Could not load DNS records for {domainName}. Please try again.</Alert>
        <Button onClick={onBack} sx={{ mt: 2 }} variant='outlined'>
          Back
        </Button>
      </Box>
    )
  }
  if (isLoading && !dnsRecords) {
    return (
      <Box
        sx={{
          display: 'flex',
          justifyContent: 'center',
          alignItems: 'center',
          minHeight: '150px',
          flexDirection: 'column',
          gap: 1,
          p: 2
        }}
      >
        <CircularProgress />
        <Typography color='text.secondary'>Loading DNS records for {domainName}...</Typography>
      </Box>
    )
  }

  const recordEntries = dnsRecords ? Object.entries(dnsRecords) : []

  return (
    <Box sx={stepStyles.container}>
      {error && <ModalAlert severity='error' title='Verification Error' message={error} sx={stepStyles.errorAlert} />}

      <Box sx={stepStyles.recordsList}>
        {recordEntries.length > 0
          ? recordEntries.map(([key, record]) => (
              <VerificationRecordItem key={key} type={record.type || 'TXT'} host={record.host} value={record.value} />
            ))
          : !isLoading && <Alert severity='info'>No DNS records currently available to display.</Alert>}
      </Box>

      <Paper elevation={0} sx={stepStyles.instructions}>
        <Typography>
          Please note that DNS changes may take some time to propagate, so you may not see the effects immediately
        </Typography>
      </Paper>

      <Box sx={stepStyles.buttonContainer}>
        <Button
          variant='contained'
          onClick={onVerify}
          disabled={isLoading || recordEntries.length === 0}
          startIcon={isLoading && <CircularProgress size={20} color='inherit' />}
          sx={stepStyles.actionButton}
        >
          {isLoading ? 'Verifying...' : 'Verify'}
        </Button>
      </Box>
    </Box>
  )
}

const stepStyles = {
  container: {
    width: '100%',
    padding: '16px',
    border: '1px solid #DBDBE6',
    borderRadius: '12px',
    backgroundColor: '#fff'
  },
  instructions: {
    p: 2,
    fontFamily: 'Plus Jakarta Sans',
    fontWeight: 400,
    fontSize: '16px',
    color: '#393946',
    borderRadius: '16px',
    border: '1px solid #DBDBE6'
  },

  recordsList: { mb: 2.5 },
  buttonContainer: {
    display: 'flex',
    flexDirection: { xs: 'column-reverse', sm: 'row' },
    justifyContent: 'flex-end',
    alignItems: 'center',
    mt: 3,
    gap: 1.5
  },
  actionButton: {
    borderRadius: '16px',
    fontFamily: 'Plus Jakarta Sans',
    fontWeight: 400,
    fontSize: '16px',
    padding: '8px 8px',
    backgroundColor: '#0246F8',
    boxShadow: 'none',
    color: '#fff',
    textTransform: 'none',
    width: '160px'
  },
  backButton: {
    width: { xs: '100%', sm: 'auto' }
  },
  errorAlert: { mb: 2 },
  infoBox: {
    p: 1.5,
    mb: 2.5,
    border: '1px solid',
    borderColor: 'warning.main',
    backgroundColor: 'warning.light',
    borderRadius: 1,
    color: 'warning.dark'
  },
  infoBoxIcon: {
    mr: 1,
    verticalAlign: 'middle'
  }
}
